const SIGNUP_POPUP_PATH = '/join/signup-popup/';

export interface BuildSignupPopupUrlParams {
    /** Current locale in `language_REGION` form (e.g. `en_US`). */
    locale: string;
    /** Path the user should return to after authenticating (no query string). */
    nextPath: string;
    /**
     * Query params from the current page to keep on the post-auth redirect,
     * including `password` when it is already in the URL.
     */
    searchParams?: Iterable<[string, string]>;
}

/**
 * Builds the monolith signup-popup URL that the limited-access flow redirects
 * logged-out users to. The `next` param is the page the user should return to
 * after authenticating, with the current query string copied onto it.
 */
export function buildSignupPopupUrl({
    locale,
    nextPath,
    searchParams,
}: BuildSignupPopupUrlParams): string {
    const nextParams = new URLSearchParams();
    if (searchParams) {
        for (const [name, value] of searchParams) {
            nextParams.append(name, value);
        }
    }

    let next = nextPath;
    const nextQuery = nextParams.toString();
    if (nextQuery) {
        next = `${nextPath}?${nextQuery}`;
    }

    const params = new URLSearchParams();
    params.set('locale', locale);
    params.set('response_type', 'json');
    params.set('next', next);

    return `${SIGNUP_POPUP_PATH}?${params.toString()}`;
}
